module.exports = __webpack_public_path__ + "img/oval-large.814d4200.png";